import { Component } from '@angular/core';

@Component({
    selector: 'app-data-manager-banner',
    templateUrl: './data-manager-banner.component.html',
    imports: [],
})
export class DataManagerBannerComponent {
}
